// material-ui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// project imports
import logo from 'assets/images/logo.png';
import { t } from 'i18n';

// ==============================|| LOGO — ICON + WORDMARK ||============================== //

export default function LogoMain() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box component="img" src={logo} alt="" sx={{ width: 36, height: 36, borderRadius: 1.5, display: 'block' }} />
      <Typography component="span" sx={{ fontSize: '1.15rem', fontWeight: 700, color: 'text.primary', whiteSpace: 'nowrap' }}>
        {t('Delivero Go')}
      </Typography>
    </Box>
  );
}
